import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import NuDate from "../../../../../Components/Utils/NuDate";

function Request() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/requestStats`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Inventory Issuance Requests</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-purple-50 text-purple-700 border border-purple-200/50">
          Internal Requests
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Item Name</th>
                <th className="py-2 px-2 text-left">Approved By</th>
                <th className="py-2 px-2 text-left">Issued To</th>
                <th className="py-2 px-2 text-right">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-2.5 px-2 font-semibold text-gray-900 truncate max-w-[120px]">{item?.item || "N/A"}</td>
                    <td className="py-2.5 px-2 text-gray-600 truncate max-w-[100px]">{item?.approvedBy || "N/A"}</td>
                    <td className="py-2.5 px-2 text-gray-600 truncate max-w-[100px]">{item?.issuedTo || "N/A"}</td>
                    <td className="py-2.5 px-2 text-right text-gray-500 font-medium">
                      {item?.date ? <NuDate value={item.date} format="DD MMM YYYY" /> : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-400">
                    No issuance requests available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Request;